import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthContext";

function Logout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [showModal, setShowModal] = useState(true);
  const { t } = useTranslation();

  // HAPPYCAP_LOGOUT_NAVIGATION_FIX_V1
  const logoutStarted = useRef(false);

  useEffect(() => {
    if (logoutStarted.current) return;
    logoutStarted.current = true;

    const performLogout = async () => {
      try {
        await logout();
        navigate("/login", { replace: true });
      } catch (err) {
        console.error("No se pudo registrar el cierre de sesión:", err);
        alert(
          "No se pudo completar el cierre de sesión. " +
          "Comprueba tu conexión e inténtalo de nuevo."
        );
        navigate(-1);
      }
    };

    performLogout();
  }, [logout, navigate]);

  return (
    <>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="spinner" />
            <p className="text-gray-700 font-medium">{t("logout.message")}</p>
          </div>
        </div>
      )}

      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 999;
        }

        .modal-content {
          background: white;
          padding: 30px;
          border-radius: 12px;
          text-align: center;
          box-shadow: 0 0 10px rgba(0,0,0,0.3);
        }

        .spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default Logout;
